
import { Button } from "@/components/ui/button";
import { NetworkAnimation } from "./NetworkAnimation";
import { RegistrationForm } from "./RegistrationForm";
import { NewsletterSubscription } from "./NewsletterSubscription";
import { AppInstall } from "./AppInstall";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/motion";

export const Contact = () => {
  const { t } = useI18n();

  return (
    <section className="app-section border-t border-border/40 bg-card/30 text-foreground">
      <div className="hero-fx pointer-events-none absolute inset-0" aria-hidden="true">
        <NetworkAnimation />
      </div>

      <div className="app-container max-w-5xl text-center">
        <Reveal>
          <h2 className="section-title">{t.contact.title}</h2>
          <p className="mx-auto mt-4 max-w-3xl text-base text-muted-foreground sm:text-lg">{t.contact.copy}</p>
          <div className="mt-6 flex justify-center">
            <RegistrationForm>
              <Button size="lg" className="h-12 px-8">{t.common.registerNow}</Button>
            </RegistrationForm>
          </div>
        </Reveal>

        <div className="mx-auto mt-10 grid max-w-3xl gap-8 text-left md:grid-cols-2">
          <Reveal delay={0.1}>
            <NewsletterSubscription />
          </Reveal>
          <Reveal delay={0.15}>
            <AppInstall />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
